import { Cirus } from "@/classes/Http";

export class UpdateProductBody {
    id: string;
    category_id?: string;
    brand_id?: string;
    image_id?: string;
	name: string;
    description?: string;
	barcode?: string;
	price?: number;
    price_with_off?: number;
	predicted_percent?: number;
}

export function updateProduct(instance_id: number, params: UpdateProductBody) {
    const path = `/instance/${instance_id}/product`;
    return Cirus.post(path, params);
}